export class UserCertification {
    id: string;
    certificationDate: string;
    expirationDate: string;
    type: string;
    score: string;

    constructor(userCertification: any) {
        if (userCertification) {
            this.id = userCertification.id;
            this.certificationDate = userCertification.certificationDate;
            this.expirationDate = userCertification.expirationDate;
            this.type = userCertification.type;
            this.score = userCertification.score;
        }
    }
}
